import { PaginationResponse } from '@models/api/common';
import { CheckInBase, CheckInForm, MyCheckIn } from '@models/checkIn';
import axios from './axios';

// GET check-in list
export const getCheckInList = async () => {
  const { data } = await axios.get<PaginationResponse<MyCheckIn[]>>(`/check_in/`);
  return data;
};

// POST check-in (create or edit)
export const postCheckIn = async (checkIn: CheckInForm) => {
  const { data } = await axios.post<MyCheckIn>(`/check_in/`, checkIn);
  return data;
};

// GET check-in detail
export const getCheckInDetail = async (checkInId: number) => {
  const { data } = await axios.get<MyCheckIn>(`/check_in/${checkInId}/`);
  return data;
};

// TODO: 나중에 삭제 UI 구현하면 적용
// DELETE check-in
export const deleteCheckIn = async () => {
  await axios.delete(`/check_in/`);
};

// PATCH read friend check-in
export const readFriendCheckIn = async (checkInId: number) => {
  await axios.patch<CheckInBase>(`/check_in/read/${checkInId}/`);
};

// POST toggle reaction on a check-in component (creates or removes)
export const toggleCheckInReaction = async (
  checkInId: number,
  emoji: string,
  component: ArchivableCheckInComponent,
) => {
  const { data } = await axios.post<{ toggled: 'on' | 'off'; id?: number; emoji?: string }>(
    `/check_in/${checkInId}/react/`,
    { emoji, component },
  );
  return data;
};

// GET active song
export const getActiveSong = async () => {
  const { data } = await axios.get<{ results: { id: number; track_id: string }[] }>(
    `/check_in/song/`,
  );
  return data.results?.[0] || null;
};

// POST song (create or update active song)
export const postSong = async (trackId: string) => {
  const { data } = await axios.post(`/check_in/song/`, { track_id: trackId });
  return data;
};

// DELETE song (deactivate)
export const deactivateSong = async (songId: number) => {
  await axios.patch(`/check_in/song/${songId}/`);
};

export type ArchivableCheckInComponent = 'battery' | 'mood' | 'thought' | 'song';

// GET reactions for a check-in component
type ReactionItem = {
  id: number;
  emoji: string;
  component?: string;
  user: { id: number; username: string };
};
export const getCheckInReactions = async (
  checkInId: number,
  component?: ArchivableCheckInComponent,
): Promise<ReactionItem[]> => {
  const { data } = await axios.get(`/check_in/${checkInId}/reactions/`, {
    params: component ? { component } : undefined,
  });
  // Handle both paginated ({ results: [...] }) and flat array responses
  if (Array.isArray(data)) return data;
  if (data.results && Array.isArray(data.results)) return data.results;
  return [];
};
